/**
 *
 * @param {"adjust_height" | "copy_text" | "download_file" | "share_files" | "update_footer" | "open_login" | "update_newsession_loaded" | "update_scroll_info" | "scroll_window" | "open_window"} name
 * @param {*} params
 */
export function emitIntent(name, ...params) {
  window.parent.postMessage(
    {
      type: "intent",
      data: {
        name,
        params
      }
    },
    "*"
  );
}



// WEBPACK FOOTER //
// ./src/newDesign/utils/emitIntent.js